<div class="tooltip" [attr.data-balloon-length]="(content | translate).length > 30 ? 'medium' : false" [attr.data-balloon]="content | translate" data-balloon-pos="left"><i class="icon">tooltip</i></div>
